import Container from './ModelViewer.container';

export default Container;
